import { render, staticRenderFns } from "./BlogComments.vue?vue&type=template&id=5394bc89&scoped=true&"
import script from "./BlogComments.vue?vue&type=script&lang=js&"
export * from "./BlogComments.vue?vue&type=script&lang=js&"
import style0 from "./BlogComments.vue?vue&type=style&index=0&id=5394bc89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5394bc89",
  null
  
)

export default component.exports